<xemex-card [title]="'home.recentlyUsed.title' | translate" titleSize="lg">
  <div class="flex flex-col divide-y divide-border-subtle pt-2">
    @for (entry of entries(); track entry.type + entry.id) {
      <xemex-list-row
        [icon]="entry.icon"
        iconVariant="accent"
        [title]="entry.primary"
        [subtitle]="entry.secondary"
        [clickable]="true"
        (rowClick)="entryClick.emit(entry.route)"
      >
        @if (entry.badges?.length) {
          <div listRowBadges class="flex items-center gap-2">
            @for (badge of entry.badges; track badge.label) {
              <xemex-status-chip [status]="badge.status" [label]="badge.label" [icon]="badge.icon" />
            }
          </div>
        }
        <span listRowActions class="text-xs text-muted whitespace-nowrap">{{ entry.timeAgo }}</span>
        <mat-icon listRowActions class="text-muted !text-lg">chevron_right</mat-icon>
      </xemex-list-row>
    } @empty {
      <p class="text-sm text-muted py-2">{{ 'home.recentlyUsed.empty' | translate }}</p>
    }
  </div>
</xemex-card>
